<template>
    <v-dialog
        v-model="showDialog"
        fullscreen
        v-if="publication"
        >
        <v-card  style="background-color:#f7f7f7">
            <v-toolbar
              class="elevation-3"
              color="primary"
              dark
            >
                <v-toolbar-title>
                    <v-toolbar-items>
                        <v-icon color="red">mdi-heart-outline</v-icon><small>{{publication.likes.length}}</small>
                        <v-icon class="ml-10">mdi-comment-outline</v-icon><small>{{publication.comments.length}}</small>
                    </v-toolbar-items>
                </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                @click="showDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text >
                <v-row>
                    <v-col cols="12" style="background-color: white">
                        <div>
                          <p class="justify-center pt-5" v-if="showComplete" v-html="publication.contentHtml? publication.contentHtml : publication.content">
                            
                          </p>
                          <p class="justify-center pt-5" v-else v-html="publication.contentHtml ? publication.contentHtml.substring(0, 150) + '...' : publication.content">
                          </p>
                          <small @click="showComplete = !showComplete" style="text-decoration: underline;cursor: pointer;">{{showComplete ? 'Ver menos' : 'Ver más'}}</small>
                          <v-carousel 
                              hide-delimiters
                              max-height="500"
                              :show-arrows="publication.images.length > 1"
                              v-if="publication.images.length > 0 || publication.video"  
                              >
                            <v-carousel-item
                              v-for="(image,j) in publication.images"
                              :key="j"
                              :src="image.image"
                              contain
                            >
                            </v-carousel-item>
                            <v-carousel-item
                              v-if="publication.video"
                            >
                            <iframe
                              width="100%"
                              height="450"
                              :src="publication.video"
                              frameborder="0"
                              allow="autoplay; encrypted-media"
                              allowfullscreen
                              class="mt-10"
                            ></iframe>
                           
                            </v-carousel-item>
                          </v-carousel>
                        </div>
                        
                    </v-col>
                    <v-col cols="12" class="pt-10">
                        <v-row justify="space-around">
                            <v-card-text>
                              <div class="font-weight-bold ml-8 mb-2">
                                Comentarios ({{commentsHtml.length}})
                              </div>
                              <div style="padding-bottom: 50px;">
                              <v-timeline
                                align-top
                                dense
                              >
                                <v-timeline-item
                                    v-for="(comment,j) in commentsHtml"
                                    :key="j"
                                    large
                                    color="#8fc6dc"
                                >
                                  
                                    <template v-slot:icon>
                                      <div v-if="comment.type_user == 'alumno'">

                                        <v-avatar size="50" title="Ver perfil" @click="openProfile(comment.alumno.IDStB,'alumno')">
                                           <div class="v-image v-responsive theme--light"><div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div><div class="v-image__image v-image__image--cover" v-bind:style="{ 'background-image': 'url(' + comment.alumno.imagen + ')','background-position': 'center center' }"></div><div class="v-responsive__content" style="width: 1229px;"></div></div>
                                        </v-avatar>

                                      </div>

                                      <div v-else>

                                         <v-avatar size="50" title="Ver perfil" @click="openProfile(comment.profesor.IDStB,'profesor')">
                                           <div class="v-image v-responsive theme--light"><div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div><div class="v-image__image v-image__image--cover" v-bind:style="{ 'background-image': 'url(' + comment.profesor.empleado.imagen + ')','background-position': 'center center' }"></div><div class="v-responsive__content" style="width: 1229px;"></div></div>
                                        </v-avatar>

                                      </div>
                                        


                                    </template>
                                  <v-card class="elevation-2">
                                      <v-card-actions style="padding-left: 20px;" >
                                      <v-spacer></v-spacer>
                                      <div v-if="comment.type_user == 'alumno'">

                                        <v-btn
                                        icon
                                        @click="deleteComment(comment.id, j)"
                                        v-if="comment.alumno.IDStB == user.IDStB"
                                      >
                                        <v-icon small color="grey">mdi-delete</v-icon>
                                      </v-btn>

                                      </div>

                                      <div v-else>

                                        <v-btn
                                        icon
                                        @click="deleteComment(comment.id, j)"
                                        v-if="comment.profesor.IDStB == user.IDStB"
                                      >
                                        <v-icon small color="grey">mdi-delete</v-icon>
                                      </v-btn>

                                      </div>
                                      


                                    </v-card-actions>

                                    <div v-if="comment.type_user == 'alumno'">

                                      <v-card-text v-bind:style="{'margin-top': comment.alumno.IDStB == user.IDStB ? '-50px' : '0'}">
                                      <strong>{{comment.alumno.Nombres}}</strong><br/>
                                      <small>Hace {{gettime(comment.updated_at)}}</small><br>
                                      <p class="mb-5" style="color:#464646" v-html="comment.commentHtml"></p>
                                      
                                    </v-card-text>

                                    </div>

                                    <div v-else>

                                      <v-card-text v-bind:style="{'margin-top': comment.profesor.IDStB == user.IDStB ? '-50px' : '0'}">
                                      <strong>{{comment.profesor.empleado.nombres}}</strong><br/>
                                      <small>Hace {{gettime(comment.updated_at)}}</small><br>
                                      <p class="mb-5" style="color:#464646" v-html="comment.commentHtml"></p>
                                      
                                    </v-card-text>

                                    </div>
                                    
                                    
                                    </v-card>


                                </v-timeline-item>
                              </v-timeline>
                            </div>
                              
                            </v-card-text>
                            <!--
                            <v-card-text class="flex-shrink-1">
                              <v-text-field
                              background-color="white"
                              label="Escribe tu comentario"
                              type="text"
                              no-details
                              outlined
                              prepend-icon="mdi-emoticon"
                              append-outer-icon="mdi-send"
                              
                              hide-details
                                />
                              </v-card-text>
                            -->
                              <v-card-text 
                              class="flex-shrink-1" 
                              style="position: fixed;bottom: 0px;background-color: white;z-index: 1000;border-top: 2px solid #8fc6dc;border-bottom: 2px solid #8fc6dc;"
                              v-if="usuarioBorrado!=1"
                              >
                                <div style="position: absolute;top:-400px;z-index: 1000">
                                  <VEmojiPicker 
                                    class="elevation-1"
                                    @select="selectEmoji" 
                                    emojiSize="25"
                                    emojisByRow="9"
                                    v-if="showEmojis"/>
                                </div>
                                <template>
                                <Mentionable
                                  :keys="['@', '#']"
                                  :items="followings"
                                  offset="6"
                                  insert-space
                                  @search="searchText = $event"
                                  @open="openKey = $event"
                                  @close="closeKey = $event"
                                  @apply="(item, key) => selectItem(item)"
                                >
                                  <v-text-field
                                    background-color="white"
                                    label="Escribe tu comentario"
                                    type="text"
                                    no-details
                                    outlined
                                    clear-icon="mdi-close-circle"
                                    clearable
                                    append-outer-icon="mdi-send"
                                    @click:append-outer="addComment"
                                    v-model="comment"
                                    hide-details
                                    required
                                    v-on:keyup="addCommentEnter"
                                    prepend-icon="mdi-emoticon"
                                    @click:prepend="showEmojis = !showEmojis"
                                    @click="showEmojis = false"
                                    @focus="showEmojis = false"
                                  >
                                </v-text-field>
                                <template #no-result>
                                  <div class="dim">
                                    No result
                                  </div>
                                </template>

                                <template #item-@="{ item }">
                                  <div class="user">
                                    <v-avatar size="25" color="#8fc6dc">
                                    <v-img :src="item.Avatar" v-if="item.Avatar"></v-img>
                                      <v-icon dark v-else>mdi-account</v-icon>
                                    </v-avatar>
                                    {{ item.value }}
                                  </div>
                                </template>
                              </Mentionable>
                            </template>
                              </v-card-text>
                          
                        </v-row>

                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import moment from "moment";
import { VEmojiPicker } from 'v-emoji-picker';
import { Mentionable } from 'vue-mention'
moment.locale('es')
export default {
name: "Publication",
    components: {VEmojiPicker, Mentionable},
    props:{
        showDialog: {
            type: Boolean,
            default: false
        },
        publication:{
            required: true,
        },
        followings:{
            type:Array,
            required: false
        }
    },
    data: () => ({
      showComplete:true,
      comment:'',
      showEmojis:false,
      selecteds:[],
      usuarioBorrado: ''
    }),
    watch: {
        showDialog (val) {
            
            if(!val){
              this.$emit('updatepublication', val)
              let a = document.getElementById('video')
              a.pause();
            }
            
        }
    },
    methods: {
      selectItem(item){
        this.selecteds.push(item)
      },
      selectEmoji(emoji) {
        console.log(emoji)
        this.comment += emoji.data;
      },
      async addComment(){
        if(this.comment){
          let ids = '';
          if(this.selecteds.length > 0){
            let taggeds = new Array();
            this.selecteds.forEach((val)=>{
              if(this.comment.includes(val.value)){
                taggeds.push(val.id);
              }
            });
            ids = taggeds.join(',');
          }
          await this.$API
          .post({
            url: "publications-comment",
            data: {
              publication_id:this.publication.id,
              comment:this.comment,
              tagged:ids
            }
          }, false).then(res => {
              this.publication.comments.push(res);
              this.comment='';
              this.showEmojis=false;
          });
        }
      },
      async deleteComment(id, index){
        if(confirm('¿Estas seguro de querer borrar el comentario?')){
          await this.$API
          .delete({
            url: "publications-comment/"+id,
            data: {
              publication_id:this.publication.id,
            }
          }).then(res => {
            if(res){
              this.publication.comments.splice(index,1)
            }
          });
        }
      },
      addCommentEnter(e){
        if (e.keyCode === 13) {
          this.addComment();
        }
      },
      gettime(date_publish){
        let current_date = moment();
        let published_date = moment(date_publish);
        return (moment.duration(current_date - published_date).humanize())
      },
      openProfile(id,tipo_usuario){
         this.$router.push('profile/'+id+'/'+tipo_usuario);  
      },
      
    },
    computed: {
      user() {
        return this.$store.getters.user;
      },
      commentsHtml() {
        const result = [];
        for (const p of this.publication.comments) {
          if(p.alumno.shadowban == 0 || p.alumno.IDStB == this.user.IDStB){
            p.commentHtml = p.comment;
            if(p.taggeds && p.taggeds.length > 0){
              p.taggeds.forEach((val)=>{
                let t = new Date().getTime();
                p.commentHtml = p.commentHtml.replace(val.shortName.trim(), '<a class="tagged" href="profile/'+val.IDStB+'/'+val.type_user+'?t='+t+'">'+val.shortName.trim()+'</a>');
              }); 
            }
            result.push(p)
          }
          
        }

        for (const p of this.publication.comments_profesor) {
          if(p.alumno.shadowban == 0 || p.alumno.IDStB == this.user.IDStB){
            p.commentHtml = p.comment;
            if(p.taggeds && p.taggeds.length > 0){
              p.taggeds.forEach((val)=>{
                let t = new Date().getTime();
                p.commentHtml = p.commentHtml.replace(val.shortName.trim(), '<a class="tagged" href="profile/'+val.IDStB+'/'+val.type_user+'?t='+t+'">'+val.shortName.trim()+'</a>');
              }); 
            }
            result.push(p)
          }
          
        }

       let nuevo =  result.sort(function (a, b){
            return new Date(b.created_at).getTime() < new Date(a.created_at).getTime();
         })

       
        return nuevo;
      },
    },
    mounted() {
      this.usuarioBorrado = this.user.borrado;
      if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
        this.$router.push({
            name: "Home"
          });
      }
    }
};
</script>

